import { styled } from '@clickcease/cc-client-components-lib'

export const GoogleTagManagerWrapperStyled = styled('div', {
  display: 'flex',
  flexDirection: 'column',
})
export const GoogleTagManagerSeparator = styled('div', {
  height: '1px',
  background: '$veryLightGray',
  margin: '17px 0px 24px 40px',
  width: '418px',
})
